import { AgencyId, Dtos } from "@inrev/common";
import { useQuery } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { adminAgencyAccountPreviewsQueryKey } from "../agency.keys";

export const useAdminFetchAgencyAccountPreviews = (id?: AgencyId) => {
	const { get } = useRequest();

	const { data, error, isLoading } = useQuery({
		queryKey: id !== undefined ? adminAgencyAccountPreviewsQueryKey(id) : [],
		queryFn: async () =>
			await get<Dtos.SuretyAccount.Preview.Get.Response[]>(`/v2/admin/agencies/${id}/accounts`),
		enabled: !!id,
	});

	return {
		agencyAccountPreviews: data,
		agencyAccountPreviewsError: error,
		agencyAccountPreviewsLoading: isLoading,
	};
};
